var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"vuestic-sidebar",class:{'sidebar-hidden': !_vm.hidden}},[_c('va-scrollbar',[_c('ul',{staticClass:"sidebar-menu"},[_vm._t("menu")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }